import * as React from "react";
import { Box } from "@amzn/awsui-components-react";
import { QueryResultItem } from "@aws-sdk/client-kendra";
import { getSearchResultDocumentUrl } from "../../../utils/search-utils";
import { CrossInstanceLink } from "./CrossInstanceLink";
import { useCurrentInstanceData } from "../../../contexts/InstanceDataContext";

interface PageSourceLinkProps {
    resultItem: QueryResultItem;
    instanceId: string;
    variant?: "compact" | "standard";
}

export const PageSourceLink: React.FC<PageSourceLinkProps> = ({
    resultItem,
    instanceId,
    variant = "standard"
}) => {
    const { instance } = useCurrentInstanceData();
    const sharedPageLibrariesEnabled = instance?.preferences?.features?.sharedPageLibrariesEnabled ?? true;
    const documentUri = getSearchResultDocumentUrl({ resultItem, instanceId, sharedPageLibrariesEnabled });

    if (variant === "compact") {
        return (
            <CrossInstanceLink
                resultItem={resultItem}
                currentInstanceId={instanceId}
                targetUrl={documentUri}
                target="_blank"
                external
                externalIconAriaLabel="Opens in a new tab"
                variant="secondary"
                fontSize="body-s"
                className="page-source-link"
            >
                View Page
            </CrossInstanceLink>
        );
    }

    return (
        <Box className="page-source-link-container">
            <CrossInstanceLink
                resultItem={resultItem}
                currentInstanceId={instanceId}
                targetUrl={documentUri}
                target="_blank"
                external
                externalIconAriaLabel="Opens in a new tab"
                className="page-source-link"
            >
                View Page
            </CrossInstanceLink>
        </Box>
    );
};
